import React, { Component, PropTypes } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import SelectList from '../components/Common/SelectList/SelectList';

import {
    setNewBookingTravelReason,
    setNewBookingCustomTravelReason,
} from '../actions/newBooking';

class TravelReasonSelectorContainer extends Component {
    render() {
        const {
            travelReasons,
            travelReasonId,
            setNewBookingTravelReason,
            person,
            otherTravelReason,
            setNewBookingCustomTravelReason,
        } = this.props;

        let freeTextProps;
        if (person.requirements.otherTravelReason) {
            freeTextProps = {
                freeTextValue: otherTravelReason,
                setFreeTextItem: setNewBookingCustomTravelReason,
            };
        }

        return (
            <SelectList
                title="Select Reason for Travel"
                items={this.props.travelReasons}
                selectedItemId={this.props.travelReasonId}
                setSelectedItem={this.props.setNewBookingTravelReason}
                {...freeTextProps}
            />
        );
    }
}

function mapStateToProps(state) {
    const { person } = state.environment;
    const { travelReasons } = state.entities;
    const { travelReasonId, otherTravelReason } = state.newBooking;

    return {
        person,
        travelReasons,
        travelReasonId,
        otherTravelReason,
    };
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        setNewBookingTravelReason,
        setNewBookingCustomTravelReason,
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(TravelReasonSelectorContainer);



// WEBPACK FOOTER //
// ./scripts/containers/TravelReasonSelectorContainer.jsx